import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AddControl from 'components/add_control';
import Button from 'shared/button';
import { associateListing } from '../api';
import { hasDifferentProperties, requiresPropertyOverride } from '../helpers';
import { newListingId } from './listing_selector';

export default function ListingSearchControls({
  deal,
  edgeCrm,
  listing,
  project,
  propertyIdOverride,
  onClose,
  onConfirm,
  onConfirmMerge,
  onCreateClick,
  onSave,
}) {
  const [saving, setSaving] = useState();
  const needsPropertySelection = !propertyIdOverride && requiresPropertyOverride(deal, project);

  async function handleConnect() {
    if (edgeCrm && !propertyIdOverride && hasDifferentProperties(deal, project)) {
      if (project.edgeResearchProperty && deal.researchPropertyId) {
        onConfirmMerge({ listing, project });
      } else {
        const propertyLabel = deal.researchProperty?.name || project.edgeResearchProperty.name;
        const confirmText = `Connecting this listing will also connect both the deal and this listing to the following
          property: ${propertyLabel}`;
        onConfirm(confirmText, deal.researchPropertyId || project.edgeResearchProperty.id);
      }
    } else {
      connectListing(propertyIdOverride);
    }
  }

  async function connectListing(propertyId) {
    setSaving(true);

    if (listing.id === newListingId) {
      window.location.assign(`${project.editPath}?deal_id_for_new_listing=${deal.id}`);
      return;
    }

    deal = await associateListing(deal, listing, propertyId);
    setSaving(false);
    onSave(deal.listing, deal.researchProperty);
    onClose();
  }

  return (
    <div className="w-100 d-flex align-items-center justify-content-between">
      <AddControl onClick={onCreateClick}>
        Create New Listing
      </AddControl>

      <div className="d-flex align-items-center gap-2">
        <Button.Cancel onClick={onClose} />
        <Button.Primary disabled={!listing || saving || needsPropertySelection} onClick={handleConnect}>
          Connect
        </Button.Primary>
      </div>
    </div>
  );
}

ListingSearchControls.propTypes = {
  deal: PropTypes.object.isRequired,
  edgeCrm: PropTypes.bool,
  listing: PropTypes.object,
  project: PropTypes.shape({
    editPath: PropTypes.string.isRequired,
  }),
  propertyIdOverride: PropTypes.number,
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onConfirmMerge: PropTypes.func.isRequired,
  onCreateClick: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
